AgrimarketServices.service("versionService", [
    function() {
        var version = "1.1.17.33";

    this.webVersion = version;
  },
]);
